import { ResponsiveBar } from '@nivo/bar';
import styled from 'styled-components';
import SubTitle from '../../components/SubTitle';

const Flex = styled.div`
  flex: 1;
  @media (max-width: 780px) {
    height: 250px !important;
    width: 100%;
  }
`;
const OverflowWrapper = styled.div`
  overflow-x: auto;
  overflow-y: hidden;
  height: 100%;
`;

const ChartWrapper = styled.div`
  height: 100%;
  @media (max-width: 780px) {
    min-width: 700px;
  }
`;

function TotalCount({ data }) {
  return (
    <Flex>
      <SubTitle>Celkový počet čakajúcich</SubTitle>
      <OverflowWrapper>
        <ChartWrapper>
          <ResponsiveBar
            data={data}
            keys={['Počet']}
            indexBy="date"
            margin={{ top: 25, right: 30, bottom: 110, left: 100 }}
            padding={0.3}
            groupMode="grouped"
            valueScale={{ type: 'linear', round: true }}
            indexScale={{ type: 'band', round: true }}
            layout="horizontal"
            borderColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
            axisTop={null}
            axisRight={null}
            axisBottom={{
              tickSize: 5,
              tickPadding: 5,
              tickRotation: 0,
              legend: 'Počet ľudí v čakárni',
              legendPosition: 'middle',
              legendOffset: 45,
            }}
            axisLeft={{
              tickSize: 5,
              tickPadding: 5,
              tickRotation: 0,
              legend: 'Dátum',
              legendPosition: 'middle',
              legendOffset: -80,
            }}
            labelSkipWidth={12}
            labelSkipHeight={12}
            labelTextColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
            colorBy="indexValue"
            colors={[
              '#a6cee3',
              '#1f78b4',
              '#b2df8a',
              '#33a02c',
              '#fb9a99',
              '#e31a1c',
              '#fdbf6f',
              '#ff7f00',
              '#cab2d6',
              '#6a3d9a',
              '#ffff99',
              '#b15928',
              '#bcbd22',
            ]
              .slice(0, data.length)
              .reverse()}
            animate={true}
            motionStiffness={90}
            motionDamping={15}
          />
        </ChartWrapper>
      </OverflowWrapper>
    </Flex>
  );
}

export default TotalCount;
